import { render, staticRenderFns } from "./tongueresult.vue?vue&type=template&id=2382dfb9&scoped=true&"
import script from "./tongueresult.vue?vue&type=script&lang=js&"
export * from "./tongueresult.vue?vue&type=script&lang=js&"
import style0 from "./tongueresult.vue?vue&type=style&index=0&id=2382dfb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2382dfb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2382dfb9')) {
      api.createRecord('2382dfb9', component.options)
    } else {
      api.reload('2382dfb9', component.options)
    }
    module.hot.accept("./tongueresult.vue?vue&type=template&id=2382dfb9&scoped=true&", function () {
      api.rerender('2382dfb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/components/tongueresult.vue"
export default component.exports